import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";

/* Round portrait (or emoji medallion) linking to a character's page. */
export const CharacterCard = ({ c, testPrefix = "character" }) => {
  const { lang } = useLang();
  return (
    <Link
      to={c.href}
      data-testid={`${testPrefix}-card-${c.id}`}
      className="char-card group flex flex-col items-center text-center p-4 rounded-3xl"
      style={{ "--acc": c.accent }}
    >
      <div className="char-portrait relative w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden flex items-center justify-center">
        <c.Icon size={40} strokeWidth={1.4} style={{ color: "#fff" }} aria-hidden="true" />
      </div>
      <div className="mt-3 font-serif text-lg leading-tight" style={{ color: "var(--star)" }}>{c.name}</div>
      <div className="mt-1 text-xs leading-snug" style={{ color: "var(--violet-soft)" }}>{lang === "fr" ? c.fr : c.en}</div>
    </Link>
  );
};

export const CharacterCardStyles = () => (
  <style>{`
    .char-card { background: rgba(14,8,32,0.55); border: 1px solid rgba(214,193,255,0.12);
      transition: transform 260ms ease, border-color 260ms ease, background-color 260ms ease; }
    .char-card:hover { transform: translateY(-4px); border-color: var(--acc); background: rgba(20,12,44,0.8); }
    .char-portrait { background: radial-gradient(circle at 30% 30%, var(--acc), rgba(10,6,20,0.9) 70%);
      box-shadow: 0 0 0 2px rgba(255,255,255,0.06), 0 0 28px -6px var(--acc);
      transition: box-shadow 260ms ease, transform 260ms ease; }
    .char-card:hover .char-portrait { transform: scale(1.05); box-shadow: 0 0 0 2px var(--acc), 0 0 40px -4px var(--acc); }
  `}</style>
);
